<style lang="scss" scoped>
    .orange{
        font-family:PingFangSC-Regular;
        color:#f68321;
    }
    .page-title {
        padding: 30px 40px 10px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;

        }
    }
    .box{
        padding:30px 20px;
        .repayment-list{
            li{
                padding:10px;
                line-height:35px;
                border:1px solid #d8d9df;
                border-radius:4px;
                margin-bottom: 20px;

                .amount-info{
                    line-height:40px;
                    font-size:18px;
                    color:#333333;
                    .amount{
                        font-size:32px;
                        color:#f68321;
                    }
                    .overdue{
                        font-size:14px;
                        color:#666666;
                    }
                }
                .date{
                    line-height:40px;
                }
                .loaninfo{
                    line-height:50px;
                    border-top:1px dashed #d8d9df;
                }
                .loaninfo p{
                    font-size:13px;
                    line-height:50px;

                }
                .payed{
                    font-size:20px;
                    color:#333333;
                    line-height:80px;
                }








                .left{
                    border-right: 1px dashed  #d8d9df;
                    h4{
                        font-size:18px;
                        color:#333333;
                        font-family: microsoft yahei;
                        font-weight:normal;


                    }
                }
                .center{
                    h3{
                        font-family: microsoft yahei;
                        font-size:36px;
                        color:#333333;
                    }
                    .warn{
                        font-family:PingFangSC-Regular;
                        font-size:12px;
                        color:#f68321;
                    }
                    .tip{
                        font-family:PingFangSC-Regular;
                        font-size:12px;
                        color:#999999;
                        line-height:20px;
                        margin-top:20px;
                    }
                }
                .right{
                    p{
                        line-height:40px;
                        text-align: right;
                    }
                    .fr{float:right}
                }

            }
            a{
                font-size:14px;
                color:#5078e6;
                text-decoration: underline;
            }
        }

    }
    button {
        width: 150px !important;margin:10px ;
    }
    .edu-link:before{
        content: " ";
        display:inline-block;
        height: 23px;
        width: 23px;
        background: url(../../assets/images/eduText.png) no-repeat;
        background-size: 100%;
        position: relative;
        top: 7px;
        right: 5px;
    }
    .edu-link{
        font-size:16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
        padding: 10px 20px;
    }

</style>

<template>
    <div>
        <div class="page-title clearfix">
            <h2>我的还款</h2>
        </div>
        <div>
            <p class="edu-link">请务必保持良好的还款习惯，维护信用记录，避免逾期上报征信机构。<router-link @click.native="doLog('PC我的借款-我的还款-信用教育详情')"  to="/borrower/eduDetail">查看详情</router-link></p>
        </div>
        <div class="box" v-loading="loading">
            <p v-if="!listData.length" style="font-size: 16px;">您目前没有需要还款的借款单。</p>
            <ul class="repayment-list">

                <li v-for="item in listData">

                    <el-row v-if="item.unclearedAmtUntilCurrPeriod>0">
                        <el-col :span="16">
                            <p class="amount-info">
                                当前应还 <span class="amount">{{item.unclearedAmtUntilCurrPeriod | currency}}  元</span>
                                <span class="overdue" v-if="item.overdue">（含逾期部分 {{item.overdueAmt | currency}} 元）</span>
                            </p>

                            <p class="date">本期还款截止日：<span class="orange">{{item.currPeriodEndTime | formatDate('YYYY年MM月DD日')}}</span></p>



                        </el-col>
                        <el-col :span="8" style="text-align: right">
                            <el-button  v-if="item.canPeriodRepay" class="fr" size="medium"  type="primary" v-loading="loading" @click="goMonthPay(item);doLog('PC我的借款-我的还款-逾期-立即还款')">立即还款</el-button>
                            <p  v-else><span class="orange">*</span> {{item.isCanPeriodRepayDesc}}</p>

                        </el-col>
                    </el-row>
                    <p class="payed"  v-if="item.unclearedAmtUntilCurrPeriod == 0">
                        本期已还，请继续保持良好的还款习惯。
                    </p>
                    <div class="loaninfo">
                        <el-row>
                            <el-col :span="16">
                                <p>借款产品：{{item.showKind}} &nbsp;&nbsp;借款申请：{{item.amount | currency}}元/{{item.period}}期 &nbsp;&nbsp;申请时间：{{ item.created | formatDate('YYYY/MM/DD')}}</p>
                            </el-col>
                            <el-col :span="8" style="text-align: right">
                                <router-link @click.native="logPlan(item)" :to="{ name: 'plan',params: { applyId: item.applyId} }">查看还款计划</router-link>
                                &nbsp;
                                <a  v-if="item.canPrepay" class="fr"  href="javascript:;" @click="goPayAll(item)">一次性结清此笔借款</a>

                            </el-col>
                        </el-row>
                    </div>

                </li>



            </ul>

        </div>

        <IsVerified :callback ="getList"  ref="verifyCmp" @showLoading = "showLoading" :visible="verifyVisible" />


    </div>
</template>
<script>
	import IsVerified from '../../components/isVerified'

	export default {

		data() {
			return {
				listData:[],
                loading:false,
				verifyVisible:false

			}

		},
		components:{IsVerified},

		computed:{
			productType(){
				return this.$store.state.productType
			},
			flowStatus(){
				return this.$store.state.flowStatus
			}
		},
        methods:{
			logPlan(item){
				if(item.overdue){
					this.doLog('PC我的借款-我的还款-逾期-还款计划')
                }
				if(item.unclearedAmtUntilCurrPeriod>0){
					this.doLog('PC我的借款-我的还款-本期待还款-查看还款计划')
                }else{
					this.doLog('PC我的借款-我的还款-本期已还款-查看还款计划')

				}
            },
			showLoading(show){
				this.loading=show

			},
			showVerify(show){
				this.verifyVisible =show
			},
			getAccountUrl(){
				this.loading = true

				this.$axios({
					method: 'post',
					url: '/user/supervise/account',
					data:{returnUrl:window.location.protocol+'//'+window.location.host+'/pcloan/borrower/repayment'}
				}).then( (res) =>{
					this.loading = false
					if(res.result){
						this.$router.push({name:'guangfaRedirect',query:{redirect:encodeURIComponent(res.data.url),toCreate:'1'}})

					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
					}


				}).catch((err)=> {
					this.loading = false
					console.warn(err)
				})
			},
			goMonthPay(item){
				let applyId =item.applyId
				_hmt.push(['_trackEvent', '点击事件', '我的还款-立即还款']);
				if(item.overdue){
					this.doLog('PC我的借款-我的还款-逾期-立即还款')
                }

				this.loading = true
				this.$axios({
					method: 'get',
					url: '/user/supervise/status',

				}).then( (res) =>{
					console.log(res)
					this.loading = false
					if(res.data.superviseStatus == '1'){//已开户,正常流程
						this.$router.push({name:'monthlyPayHeng2',params:{applyId}})

					}else{
						_hmt.push(['_trackEvent', '判断事件', '我的还款-立即还款-不能还款']);

						this.getAccountUrl()
                        if(item.overdue){
							this.doLog('PC我的借款-我的还款-逾期-立即还款-去开户')

						}

					}



				}).catch((err)=> {
					this.loading = false
					console.warn(err)
				})
            },
			goPayAll(item){
				let applyId =item.applyId

				_hmt.push(['_trackEvent', '点击事件', '我的还款-一次性结清']);

				this.loading = true
				this.$axios({
					method: 'get',
					url: '/user/supervise/status',

				}).then( (res) =>{
					console.log(res)
					this.loading = false
					if(res.data.superviseStatus == '1'){//已开户,正常流程
						this.$router.push({name:'payAllHeng2',params:{applyId}})

					}else{
						this.getAccountUrl()
						if(item.overdue){
							this.doLog('PC我的借款-我的还款-逾期-立即还款-去开户')

						}
						if(item.unclearedAmtUntilCurrPeriod == 0){
                            this.doLog('PC我的借款-我的还款-本期已还款-一次性结清-去开户')
						}
					}



				}).catch((err)=> {
					this.loading = false
					console.warn(err)
				})
            },
			getList(){
				this.loading=true
				this.$axios({
					method: 'get',
					url: '/borrows/list',
					params: {
						offset: 1,
						limit:100,
						statusList:'D_1,E_0'
					},
				}).then( (res) =>{
					console.log(res)
					this.loading=false
					this.listData = res.data.dataList
                    for(var i = 0; i<this.listData.length; i++){
						localStorage.setItem(this.listData[i]['applyId'],JSON.stringify(this.listData[i]))
                    }



				}).catch( (err)=> {
					this.loading=false

					if(err.code = "403"){
						this.$refs.verifyCmp.isVerified();
						return this.showVerify(true)
					}
					this.$alert('系统错误，请稍后再试', '提示', {
						confirmButtonText: '确定',
					});

					console.warn(err)
				})
            },
            getDetail(){
				this.$axios({
					method: 'get',
					url: '/borrows/'+this.$route.params.applyId+'/repayment',
				}).then( (res) =>{
					console.log(res)


				}).catch(function (err) {
					console.warn(err)
				})
            }

        },
        mounted(){
			this.getList()
        }
	}
</script>